// extracted by mini-css-extract-plugin
export default {"inputContainer":"Form_inputContainer__Sscpi","containerLogo":"Form_containerLogo__ez0jD","selected":"Form_selected__JXQdc","linkButton":"Form_linkButton__OKhs0"};